import React, { useRef } from 'react';
import { ArticleBody } from './ArticleBody';
import { CtaBox } from './CtaBox';
import { CommentsSection } from './CommentsSection';
import { VisitorInfoBar } from './VisitorInfoBar';
import { useVisitorLocation } from '../hooks/useVisitorLocation';
import { useReadingTime } from '../hooks/useReadingTime';
import { heroImage } from '../data/sectionImages';
export function Article() {
  const {
    date,
    city,
    countryCode,
    timezone,
    latitude,
    longitude,
    resolved
  } = useVisitorLocation();
  const contentRef = useRef<HTMLDivElement>(null);
  const readingMinutes = useReadingTime(contentRef);
  const bylinePlace = city ?? (resolved ? 'Mi Cocina Natural' : '');
  return <article className="mx-auto max-w-article px-4 pb-14 pt-8 sm:px-6 sm:pt-12" data-id="element-7" data-mp="knz6ne8g0t0w">
      <p className="font-sans text-[0.72rem] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-8" data-mp="kq26epzee0it">
        Nutrición digestiva / Mujeres +35
      </p>

      <div ref={contentRef} data-id="element-9" data-mp="umyamji9k0hk">
        <h1 className="mt-3 font-serif text-[2rem] font-bold leading-[1.15] tracking-tight text-ink sm:text-[2.6rem]" data-id="element-10" data-mp="unzw7hwwo5dj">
          La razón por la que muchas mujeres se inflaman aunque «coman sano» cada noche
        </h1>

        <p className="mt-2 font-sans text-[0.8rem] text-ink-soft" data-id="element-11" data-mp="1mbwq5qtuol2s">📅 Publicado el: {date}</p>
        <VisitorInfoBar city={city} timezone={timezone} latitude={latitude} longitude={longitude} data-id="element-12" data-mp="1qdrrgvbs6ygk" />

        <h2 className="mt-5 font-serif text-[1.15rem] font-normal italic leading-relaxed text-ink-soft sm:text-[1.3rem]" data-id="element-13" data-mp="20amn96go6kr5">
          El problema podría no estar solo en lo que comes, sino en lo que tu cuerpo logra digerir
          cuando llega la noche.
        </h2>

        <div className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-1 border-y border-brand-blush py-3 font-sans text-[0.78rem] text-ink-muted" data-id="element-14" data-mp="2e187ayhv10qm">
          <span className="flex items-center gap-1.5 font-semibold text-ink" data-id="element-15" data-mp="2j1nipkikzy5y">
            Por: Redacción {bylinePlace}
            {city && countryCode && <img src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`} alt={`Bandera ${countryCode}`} className="h-3 w-[18px] rounded-[2px] object-cover shadow-[0_0_0_1px_rgba(0,0,0,0.08)]" data-id="element-16" data-mp="nwwj7rpbaix4" />}
          </span>
          <span aria-hidden="true" data-id="element-17" data-mp="swiz68wiyd9m">|</span>
          <span data-id="element-18" data-mp="svhcf765c2c2">Actualizado hoy</span>
          <span aria-hidden="true" data-id="element-19" data-mp="sufxuspx8xpl">|</span>
          <span data-id="element-20" data-mp="16mmesh0wf8q3">{readingMinutes} min de lectura</span>
        </div>

        <figure className="mt-7" data-id="element-21" data-mp="12m2fp7wrlv1b">
          <img src={heroImage.src} alt={heroImage.alt} className="aspect-[16/9] w-full rounded-sm bg-brand-blush object-cover" data-id="element-22" data-mp="12l0w2f1oo07z" />
          <figcaption className="mt-2 font-sans text-xs leading-relaxed text-ink-muted" data-id="element-23" data-mp="1bm8serkn2qzf">
            {heroImage.caption}
          </figcaption>
        </figure>

        <ArticleBody data-id="element-24" data-mp="3ifawnz0gvo3q" />
      </div>

      <CtaBox data-id="element-25" data-mp="3dedidxikve7i" />

      <CommentsSection data-id="element-26" data-mp="3dex0pfc544m2" />
    </article>;
}